<template>
    <auth-container>
        <v-card
            flat
            min-width="330px"
            width="100%"
        >
            <v-card-text>
                <h3
                    class="text-uppercase mb-1 font-weight-medium oswald-font-family accent--text"
                >
                    Welcome to
                </h3>
                <h1
                    class="login-title oswald-font-family text-uppercase mb-10 font-weight-bold"
                    :class="[$vuetify.theme.dark ? 'white--text' : 'primary--text']"
                    :style="isMobile ? 'font-size: 1.5rem;' : ''"
                >
                    SureX
                </h1>
                <v-form
                    @submit.native.prevent="doLogin"
                    ref="loginForm"
                    class="text-center"
                    lazy-validation
                    v-on:keyup.enter="doLogin"
                >
                    <v-text-field
                        class="title-branding custom-input"
                        :class="autofilled ? '' : 'autofill-input'"
                        label="Email"
                        v-model="login.email"
                        :rules="[
                            v => !!v || 'Email is required.',
                            v => v.length > 4 || 'Email must be longer than 5 characters'
                        ]"
                        name="email"
                        type="text"
                        filled
                        autocapitalize="off"
                        autocorrect="off"
                        :disabled="attempting"
                        :placeholder="!autofilled ? ' ' : ''"
                        @animationstart="autofillForm"
                    ></v-text-field>

                    <v-text-field
                        class="title-branding custom-input"
                        :class="autofilled ? '' : 'autofill-input'"
                        label="Password"
                        v-model="login.password"
                        filled
                        name="password"
                        :rules="[ v => !!v || 'Password is required.' ]"
                        :append-icon="viewPassword ? '$mdiEye' : '$mdiEyeOff'"
                        @click:append="() => (viewPassword = !viewPassword)"
                        :type="viewPassword ? 'text' : 'password'"
                        :disabled="attempting"
                        :placeholder="!autofilled ? ' ' : ''"
                    ></v-text-field>

                    <div
                        class="d-flex justify-center align-center flex-wrap"
                    >
                        <v-checkbox
                            :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                            label="Remember me"
                            v-model="login.remember"
                            value="1"
                            :disabled="attempting"
                            :color="$vuetify.theme.dark ? 'white' : 'primary'"
                        ></v-checkbox>

                        <v-spacer></v-spacer>

                        <v-btn
                            class="custom-button"
                            type="submit"
                            color="background"
                            :loading="attempting"
                            :small="isMobile"
                        >
                            Login
                        </v-btn>
                    </div>
                </v-form>
                <v-alert
                    class="mt-3"
                    :value="message !== ''"
                    color="error"
                    dark
                >
                    {{ message }}
                </v-alert>
            </v-card-text>
        </v-card>
    </auth-container>
</template>

<script>
    import AuthContainer from './Auth';

    export default {
        data() {
            return {
                login: {
                    email: '',
                    password: '',
                    remember: 0
                },

                viewPassword: false,

                message: '',

                attempting: false,

                test: false,

                autofilled: false,
            }
        },

        components: {
            AuthContainer
        },

        name: 'Login',

        mounted() {
            document.title = this.$store.getters['application/getName'] + ' | Login';
        },

        watch: {
            'login.username'() {
                this.autofilled = true;
            },
        },

        computed: {
            shouldRedirect() {
                return this.$store.getters['application/shouldRedirect'];
            },
            redirectUrl() {
                return this.$store.getters['application/getRedirectUrl'];
            }
        },

        methods: {
            goToForgotPasswordPage() {
                if (this.login.username !== '') {
                    this.$router.push('/password/reset?username=' + this.login.username)
                } else {
                    this.$router.push('/password/reset')
                }
            },
            doLogin() {
                this.message = '';

                if (this.$refs.loginForm.validate()) {

                    this.attempting = true;

                    this.$store.dispatch('application/getNewCSRFToken')
                        .then((response) => {
                            window.axios.post('/login', this.login)
                                .then(response => {
                                    this.$store.commit('auth/setUser', response.data.user);
                                    this.$store.commit('application/setCSRFToken', response.data.token);

                                    if (this.shouldRedirect) {
                                        this.$router.push(this.redirectUrl);
                                        this.$store.dispatch('application/setRedirectUrl', null);
                                    } else {
                                        window.location = '/docs/master/overview';
                                    }

                                    this.attempting = false;
                                })
                                .catch(error => {
                                    if (typeof error.response.data.message !== 'undefined') {
                                        this.message = error.response.data.message;
                                    } else if (error.response.status == 419) {
                                        this.message = 'Please refresh this page.';
                                    } else {
                                        this.message = 'Whoops! Something went wrong! <br> Please try again later.';
                                    }

                                    this.attempting = false;
                                });
                        });
                }
            },
            autofillForm(e) {
                console.log(e.target.value);

                console.log(e);
            }
        }
    }
</script>
